<template>
  <div
    v-if="value"
    :class="['banner', value.template]"
  >
    <div
      v-if="isType(ENUMS.BANNER_TYPES.BIG_BANNER)"
      class="justify-center column items-center"
    >
      <div class="video-badge text-center text-27-700">
        <div
          v-for="(line, index) in heading"
          :key="index"
          class="bg-primary"
          v-html="line"
        />
      </div>

      <q-video
        v-if="video"
        class="border-radius-10"
        style="width: 600px; height: 300px"
        :src="video"
      />
      <div class="q-mt-lg row flex justify-center">
        <div
          class="col-8 text-center text-grey text-17-400"
          v-html="value.description"
        />
      </div>
      <div class="q-mt-lg">
        <AppButton
          :label="value.link.title"
          :href="value.link.url"
          :target="value.link.target"
          full-width
          text-color="dark"
          type="a"
          align="between"
        />
      </div>
    </div>
    <template v-else-if="isType(ENUMS.BANNER_TYPES.IMAGE)">
      <a
        :href="value.link.url"
        :target="value.link.target"
      >
        <q-img
          :src="value.media.url"
          width="300px"
        />
      </a>
    </template>
    <template v-else-if="isType(ENUMS.BANNER_TYPES.SMALL_BANNER)">
      <q-img
        :src="value.media.url"
        width="300px"
      >
        <div class="caption">
          <AppButton
            :label="value.link.title"
            :href="value.link.url"
            :target="value.link.target"
            padding="5px 22px"
            class="text-21-700"
            full-width
          />
        </div>
      </q-img>
    </template>
  </div>
</template>

<script>
import AppButton from 'common/components/buttons/AppButton';
import { mapGetters } from 'vuex';

export default {
  name: 'Banner',
  components: { AppButton },
  props: {
    type: {
      type: String,
      required: true,
    },
    location: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('app', ['getBanner']),
    value() {
      return this.getBanner(this.type, this.location);
    },
    video() {
      const { type, source, url } = this.value.media;
      if (type === 'video') {
        const sources = {
          vimeo: 'https://player.vimeo.com/video/{id}',
          youtube: 'https://youtube.com/embed/{id}',
        };
        return sources[source].replace('{id}', url);
      }
      return undefined;
    },
    heading() {
      return this.value.heading.split(/\r?\n/).filter((line) => line);
    },
  },
  methods: {
    isType(type) {
      return this.value.template === type;
    },
  },
};
</script>

<style scoped lang="scss">
.banner {
  &.bigBanner {
    .video-badge {
      width: 330px;
      margin-bottom: -35px;
      z-index: 1000;
      transform: rotate(352deg);

      div {
        display: inline-block;

        &:first-child {
          border-top-left-radius: 15px;
          border-top-right-radius: 15px;
          padding: 10px 50px;
        }

        &:last-child {
          border-radius: 15px;
          padding: 10px 80px;
        }
      }
    }
  }

  &.image {
    .q-img {
      border-radius: 20px;

      .caption {
        width: 100%;
        bottom: 0;
        text-align: center;
        font-size: 30px;
        font-weight: 700;
        height: 150px;
      }
    }
  }

  &.smallBanner {
    .q-img {
      .caption {
        background: transparent;
        bottom: 0;
        width: 100%;
        padding: 20px 27px;

        a {
          border-radius: $radius-8;
          background: #2A81CD !important;
        }
      }
    }
  }
}
</style>
